import React from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { RequestsTable, PrivateLayout } from '../components';
import { FeatureGuard } from '../components/multi-tenant/FeatureGuard';
import { navigateToServiceRequest } from '../redux';

export const RequestsView = () => {
  const dispatch = useDispatch();

  const renderButton = () => {
    return (
      <FeatureGuard contentKey='service-request.manage'>
        <Button variant='secondary-new' size='sm' onClick={() => dispatch(navigateToServiceRequest())}>
          <i className='fa-light fa-file-circle-plus'></i> Start a New Request
        </Button>
      </FeatureGuard>
    );
  };

  return (
    <PrivateLayout
      pageTitle='requests'
      pageIcon={<i className='fa-light fa-cabinet-filing'></i>}
      subtoolbarChildren={renderButton()}>
      <RequestsTable enableExternalFilters />
    </PrivateLayout>
  );
};
